/* @flow */

export default {
  DEALER_HOMEPAGE: 'dealer.baseInfo.homepage',
  DEALER_NAME_LINE_1: 'dealer.baseInfo.name1',
  DEALER_NAME_LINE_2: 'dealer.baseInfo.name2',
  DEALER_NAME_LINE_3: 'dealer.baseInfo.name3',
  DEALER_NAME_LINE_4: 'dealer.baseInfo.name4',
  DEALER_NAME_LINE_5: 'dealer.baseInfo.name5',
  DEALER_ADDRESS_LINE_1: 'dealer.address.line1',
  DEALER_ADDRESS_LINE_2: 'dealer.address.line2',
  DEALER_ADDRESS_LINE_3: 'dealer.address.line3',
  DEALER_ADDRESS_CITY: 'dealer.address.city',
  DEALER_ADDRESS_ZIPCODE: 'dealer.address.zipcode',
  DEALER_ADDRESS_CITY_ADDON_1: 'dealer.address.cityAddon1',
  DEALER_ADDRESS_CITY_ADDON_2: 'dealer.address.cityAddon2',
  DEALER_ADDRESS_DISTANCE_DISTANCE: 'dealer.address.distance.distance',
  DEALER_ADDRESS_DISTANCE_AIR_DISTANCE: 'dealer.address.airDistance.distance',
  DEALER_ADDRESS_DISTANCE_TIME: 'dealer.address.distance.time',
  DEALER_CONTACT_NAME: 'dealer.contact.name',
  DEALER_CONTACT_PHONE: 'dealer.contact.phone',
  DEALER_CONTACT_FAX: 'dealer.contact.fax',
  DEALER_CONTACT_EMAIL: 'dealer.contact.email',
  DEALER_PERSON_EMAIL: 'dealer.person.email',
  DEALER_PERSON_FAX: 'dealer.person.fax',
  DEALER_PERSON_PHONE: 'dealer.person.phone',
  DEALER_PERSON_IMAGE: 'dealer.person.image',
  DEALER_C_ACTIVITY_TYPES: 'dealer.activityTypes',
  DEALER_C_ACTIVITY_TYPES_HIGHLIGHTED: 'dealer.activityTypes.highlighted'
};
